import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import smoothscroll from "smoothscroll-polyfill";
import { webBg, webp } from "@/common/webp.js";
import VueLazyload from "vue-lazyload";


// IE 平滑滚动兼容
smoothscroll.polyfill();

import "amfe-flexible";
import "normalize.css";

//移动端调试工具
import VConsole from "vconsole";

// 自定义Toast
import toast from "@/components/Toast/toast";

// 自定义Loading
import loading from "@/components/Loading/loading";

/**
 * 测试环境启用vconsole
 */
if (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "beta") {
  new VConsole();
}
// new VConsole();

const app = createApp(App);
app.directive("webpb", webBg).directive("webp", webp);
app
  .use(router)
  .use(store)
  .use(VueLazyload)
  .use(toast)
  .use(loading)
  .mount("#app");
